import React from 'react';

import { useNotification } from 'utils/hooks';
import { INotification } from 'utils/types';
import Notification from 'components/Notification';

interface INotificationContext {
  notification?: INotification;
  addNotification: Function;
  removeNotification: Function;
}

export const NotificationContext = React.createContext<INotificationContext>({
  notification: undefined,
  addNotification: () => {},
  removeNotification: () => {},
});

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { notification, addNotification, removeNotification } =
    useNotification();
  return (
    <NotificationContext.Provider
      value={{ notification, removeNotification, addNotification }}
    >
      <Notification
        notification={notification}
        clearNotification={removeNotification}
      />
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
